// =============================================================================
// /invite/complete – Post–email-confirmation redirect target.
// Supabase confirm link sends users here; we redirect to /invite?token=... so
// InvitePage runs accept flow and routes into the property.
// Add https://portal.stravo.ai/invite/complete to Supabase Auth → URL Configuration → Redirect URLs.
// =============================================================================

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getInviteToken } from "@/lib/inviteTokenStorage";

export default function InviteCompletePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getInviteToken();
    if (token) {
      navigate(`/invite?token=${encodeURIComponent(token)}`, { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <p className="text-muted-foreground">Taking you to your invite…</p>
    </div>
  );
}
